module.exports = __webpack_public_path__ + "assets/2496e61964a9a23d29d376981ffd21b5.mp3";